'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRequestedStepFromPath = getRequestedStepFromPath;

var _Url = require('urlinator/Url');

var _Url2 = _interopRequireDefault(_Url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getRequestedStepFromPath() {
  var stepUrl = new _Url2.default(window.location);
  var stepUrlChunks = stepUrl.pathname.split('/');
  return stepUrlChunks[stepUrlChunks.length - 1];
}